import React from "react"
import Layout from "../components/layout"
import LibraryContent from "../components/librarycontent"
import "../css/content-library.css"
import SEO from "../components/seo"
import smileGuy from "../images/smiling-guy.png"

function toggleScrollButton () {
  var scrollUpButton = document.getElementById("fixedScrollUp")

  window.addEventListener('scroll', () => {
    if (window.scrollY >= window.innerHeight) {
      scrollUpButton.classList.add("cl-visible")
    } else {
      scrollUpButton.classList.remove("cl-visible")
    }
  })
}

class ContentLibrary extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      documentData: null
    }
  }

  componentDidMount () {
    toggleScrollButton();
  }

  scrollHandler (anchor) {
    var anchorEl = document.getElementById(anchor)
    anchorEl.scrollIntoView({behavior: "smooth", block: "center"});
  }

  render () {
    return (
      <Layout>
        <SEO title="Content Library"  />
        <div id="fixedScrollUp" onClick={() => {document.getElementById("___gatsby").scrollIntoView({behavior: "smooth"});}}>Back to the top</div>
        <div className="mainContainer" style={{paddingBottom: 0}}>
          <div id="cl-header" className="centeredContainer">
            <div className="cl-header-img">
              <img src={smileGuy}/>
            </div>
            <div className="cl-header-text">
              <h2>Resources for Every Aspect of Cyber Security Readiness and Training</h2>
              <p>Whether you’re just getting started with a career in cyber security, protecting a larger organization, or  simply curious, we have resources to help you on your journey.</p>
            </div>
          </div>
        </div>
        <div className="mainContainer gray">
          <div id="cl-nav" className="centeredContainer wrap">
            <button onClick={() => this.scrollHandler("cl-eBooks")} className="cl-nav-button flat-button">E-Books</button>
            <button onClick={() => this.scrollHandler("cl-infographics")} className="cl-nav-button flat-button">Infographics</button>
            <button onClick={() => this.scrollHandler("cl-studies")} className="cl-nav-button flat-button">Case Studies</button>
            <button onClick={() => this.scrollHandler("cl-whitePapers")} className="cl-nav-button flat-button">White Papers</button>
            <button onClick={() => this.scrollHandler("cl-webinars")} className="cl-nav-button flat-button">Webinars</button>
            <button onClick={() => this.scrollHandler("cl-videos")} className="cl-nav-button flat-button">Videos</button>
          </div>
        </div>
        <div className="mainContainer" style={{paddingTop: 0}}>
          <LibraryContent type="eBooks"/>
          <LibraryContent type="infographics"/>
          <LibraryContent type="studies"/>
          <LibraryContent type="whitePapers"/>
          <LibraryContent type="webinars"/>
          <LibraryContent type="videos"/>
        </div>
      </Layout>
    )
  }
}

export default ContentLibrary;

// <LibraryContent type="videos"/>
// <button onClick={() => this.scrollHandler("cl-videos")} className="cl-nav-button flat-button">Videos</button>

// <LibraryContent type={"infographics"}/>
// <LibraryContent type="videos"/>
// <LibraryContent type="whitePapers"/>
// <LibraryContent type="webinars"/>
